(() => {
  function enhance(root) {
    if (root.dataset.layoutReady) return;
    const form = root.querySelector('form[id^="AddToCartForm"]');
    if (!form) return;
    const preview = form.querySelector('.mockup-preview');
    const warning = preview?.previousElementSibling;
    const slot = root.querySelector('[data-dinosaur-preview-slot]');
    if (preview && slot) {
      const frame = document.createElement('div');
      frame.className = 'dinosaur-preview-frame';
      frame.append(preview);
      if (warning?.tagName === 'LABEL') slot.append(warning);
      slot.append(frame);
      const resize = () => {
        const width = Math.min(slot.clientWidth || 450, 650);
        frame.style.width = width + 'px';
        frame.style.height = 1157 * width / 2811 + 'px';
        preview.style.transform = 'scale(' + width / 450 + ')';
      };
      resize();
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(resize).observe(slot);
      else window.addEventListener('resize', resize);
    }
    const name = form.querySelector('#custom-name');
    const group = name?.closest('.product-form__input');
    if (group) {
      const heading = document.createElement('p');
      heading.className = 'form__label';
      heading.textContent = JSON.parse(root.querySelector('[data-dinosaur-personalise]').textContent);
      group.prepend(heading);
      group.dataset.nameFontGroup = 'true';
    }
    const notes = form.querySelector('#custom-message')?.closest('.product-form__input');
    if (notes) {
      const details = document.createElement('details');
      details.className = 'dinosaur-mug-notes';
      const summary = document.createElement('summary');
      summary.textContent = notes.querySelector('label').textContent.trim();
      notes.before(details);
      details.append(summary, notes);
    }
    let step = 0;
    for (const field of form.querySelectorAll(':scope > .product-form__input')) {
      const label = field.querySelector(':scope > .form__label');
      if (!label) continue;
      const badge = document.createElement('span');
      badge.className = 'step';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = String(++step);
      label.prepend(badge);
      label.classList.add('dinosaur-mug-step-label');
    }
    const selectedFont = form.querySelector('#selectedFont');
    selectedFont.setAttribute('tabindex', '0');
    selectedFont.setAttribute('role', 'button');
    selectedFont.setAttribute('aria-haspopup', 'listbox');
    selectedFont.setAttribute('aria-labelledby', 'DinosaurFontLabel');
    form.querySelector('label[for="custom-font"]').id = 'DinosaurFontLabel';
    selectedFont.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectedFont.click();
      }
    });
    const review = form.querySelector('[data-atelier-review]');
    if (review) review.open = true;
    root.dataset.layoutReady = 'true';
  }
  const init = () => document.querySelectorAll('[data-dinosaur-mug]').forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
